module.exports = __webpack_public_path__ + "static/media/bFriday-small.fae82f33.gif";